import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './dashboard/layouts/layout.component';

// Auth


import { QuicklinkStrategy } from 'ngx-quicklink';
import { GeneralErrorComponent } from './extraspages/errors/general-error/general-error.component';
import { AuthGuard } from './core/authservice/guards/auth.guard';
import { AdminAuthGuard } from './core/authservice/guards/admin.guard';
import { RedirectComponent } from './services/redirect.component';
import { TeacherAuthGuard } from './core/authservice/guards/teacher.guard';
import { SuperAdminAuthGuard } from './core/authservice/guards/superadmin.guard';
import { LandingLayoutComponent } from './landing/layout/landingpage/landing-layout.component';
import { OnlyHomePageGuard } from './core/authservice/guards/only-homepage.guard ';
import { StudentAuthGuard } from './core/authservice/guards/student.guard';
import { StudentLayoutComponent } from './student/layouts/student-layout.component';

const routes: Routes = [
  { path: '',
    component: LandingLayoutComponent, 
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule),
    canActivate: [OnlyHomePageGuard],
  },
  {
    path: 'my-learning',
    loadChildren: () => import('./student/layouts/student-layout.module').then(m => m.StudentLayoutModule),
    canActivate: [AuthGuard, StudentAuthGuard],
  },
  {
    path: 'auth', 
    loadChildren: () => import('./core/authservice/auth.module').then(m => m.AuthModule) 
  },
  { 
    path: 'dashboard', 
    component: RedirectComponent, 
    pathMatch: 'full' 
  },
  { 
    path: 'profile',  
    component: LayoutComponent, 
    loadChildren: () => import('./account/profile/profle.module').then(m => m.ProfileModule), 
    canActivate: [AuthGuard] 
  },
  { 
    path: 'superadmin', 
    component: LayoutComponent, 
    loadChildren: () => import('./dashboard/pages/superadmin/superadmin.module').then(m => m.SuperAdminModule), 
    canActivate: [AuthGuard, SuperAdminAuthGuard] 
  },
  { 
    path: 'institution', 
    component: LayoutComponent, 
    loadChildren: () => import('./dashboard/pages/institution/institution.module').then(m => m.InstitutionModule), 
    canActivate: [AuthGuard, AdminAuthGuard] 
  },
  { 
    path: 'teacher', 
    component: LayoutComponent, 
    loadChildren: () => import('./dashboard/pages/teachers/teachers.module').then(m => m.TeachersModule), 
    canActivate: [AuthGuard, TeacherAuthGuard] 
  },
  { 
    path: 'error', 
    loadChildren: () => import('./extraspages/errors/errors.module').then(m => m.ErrorsModule)
  },
  {
    path: 'error-page',
    component: GeneralErrorComponent
  },
  { 
    path: '**', 
    redirectTo: 'error-page' 
  } 
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, 
      { preloadingStrategy: QuicklinkStrategy, 
        //initialNavigation: 'enabledBlocking' 
        })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
